module.exports = __webpack_public_path__ + "static/img/finish.c97869e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/finish.png
// module id = 28JT
// module chunks = 1